import {getLidarFileNames} from "../../getLidarFileNames";



export const montana_sample = async (accessToken) =>  {
  try {
    const main_path = 'processed-lidar-data/montana-sample/';
    const raw_lidar_paths = await getLidarFileNames(main_path, accessToken)
    const lidar_paths = raw_lidar_paths.data.map(item => item.replace(main_path, '').replace('/', ''));
  return lidar_paths.map((path) => {
  const match = path.match(/\d{8}/);
    let date = '';
if (match) {
  const dateStr = match[0]; // "11082025"

  const month = dateStr.slice(0, 2);
  const day = dateStr.slice(2, 4);
  const year = dateStr.slice(4, 8);

  const readableDate = `${month}/${Number(day)}/${year}`;
  date = readableDate;

}  return {
    url: `${process.env.REACT_APP_LIDAR_CDN_URL}/montana-sample/${path}`,
    name: `Montana - ${path}`,
    description: `Scan of processed Montana sample data`,
  date_uploaded: new Date(date),
  data_identifier: 'montana',
  collector: 'NV5',
  projection: `+proj=utm +zone=12 +datum=WGS84 +to_meter=1 +no_defs`,
  }})
  } catch (error) {
    console.error('Error fetching Montana lidar paths:', error);
    return [];
  }
 
};
